import { configFetch as fetch } from '@laigu/utils';

export const getConversationTagsApi = ({ entId }) => {
  return new Promise((resolve, reject) => {
    fetch({
      url: '/conversation/tags',
      method: 'get',
      params: {
        ent_id: entId
      }
    })
      .then(req => {
        // 处理返回的数据
        resolve(req.data.conv_tags);
      })
      .catch(e => {
        reject(e);
      });
  });
};

export const deleteConversationTagApi = id => {
  return fetch({
    url: `/conversation/tags/${id}`,
    method: 'delete'
  });
};

export const createConversationTagApi = ({ color, level, parentId, parent_id, tag_name, tagName }) => {
  return fetch({
    url: `/conversation/tags`,
    method: 'post',
    data: {
      color,
      level,
      parent_id: window.parseInt(parent_id ?? parentId),
      tag_name: tag_name || tagName
    }
  });
};

export const updateConversationTagApi = ({ color, level, parentId, tagName, id, parent_id, tag_name }) => {
  return fetch({
    url: `/conversation/tags/${id}`,
    method: 'put',
    data: {
      color,
      level,
      parent_id: window.parseInt(parentId || parent_id),
      tag_name: tagName || tag_name
    }
  });
};

const getOption = list =>
  list.map(val => ({
    ...val,
    label: val.name,
    value: val.id
  }));
// 获取tags
export const getCustomerTagApi = () => {
  return fetch({
    url: '/agent/client_tags',
    method: 'get'
  }).then(res => {
    if (res && res.data && res.data.client_tags) {
      const tags = getOption(res.data.client_tags);
      return tags.sort((a, b) => a.rank - b.rank);
    }
    return [];
  });
};

export const getCategoryList = type => {
  return fetch({
    method: 'POST',
    url: '/unified-api/tag/v1/category/list',
    data: { biz_type: type }
  }).then(res => res?.data?.data?.data || []);
};

export const addCustomerTagApi = data => {
  return fetch({
    url: '/agent/client_tags',
    method: 'POST',
    data
  });
};

export const updateCustomerTagApi = (tagId, data) => {
  return fetch({
    url: `/agent/client_tags/${tagId}`,
    method: 'PUT',
    data
  });
};

export const removeCustomerTagApi = tagId => {
  return fetch({
    url: `/agent/client_tags/${tagId}`,
    method: 'DELETE'
  });
};
